import { useNavigate, useSearchParams } from "react-router-dom";
import Button from "../../../component/Button";
import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";

export const StepThree = () => {
  const isMobile = useResponsiveMobile(900);
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const navigate = useNavigate();
  return (
    <div className="w-full md:max-w-[1012px] md:h-[1009px] p-8 rounded-3xl md:p-[100px] bg-white gap-20 flex flex-col items-center justify-center shadow-[0_4px_80px_0_rgba(0,0,0,0.1)]">
      <div className="flex flex-col gap-[50px] items-center justify-center w-full">
        <img
          src={
            isMobile ? "/assets/images/logo/logo_blue.png" : "/assets/images/logo/logo_black.png"
          }
          width={isMobile ? 44 : 78}
          alt="logo"
        />
        <div className="flex flex-col gap-5 md:gap-10 w-full">
          <span className="font-bold text-[24px] md:text-display text-center">
            {type === "adoption" ? (
              <> 도입 문의가 {isMobile ? <br /> : ""} 접수되었습니다</>
            ) : (
              "소개신청서 신청이 완료되었습니다"
            )}
          </span>
          <span className="font-normal text-[#4D4F58] text-[16px] md:text-heading1_2 text-center">
            작성해주신 내용을 바탕으로 <br /> 담당자가 빠른 시일 내에 {isMobile ? <br /> : ""}{" "}
            연락드릴 예정입니다.
          </span>
        </div>
      </div>
      <img src="/assets/images/icon/handshake.png" alt="handshake" width={206} />
      <div className="flex flex-col gap-3 md:gap-6 w-full">
        <Button
          className="h-14 md:h-20 text-base rounded-[12px] md:text-[28px] font-normal bg-[#0079FF]"
          size="lg"
          onClick={() => {
            navigate("/");
          }}
        >
          품 둘러보기
        </Button>
        <span className="text-center font-normal text-[14px] md:text-[20px] text-[#878C96]">
          *영업일 기준 1~2일 이내 연락 드리겠습니다
        </span>
      </div>
    </div>
  );
};
